import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Switch, Route } from 'react-router-dom';
import { updateAccessStatus, resetState, hideNotify } from 'vendor/application/disptach';
import Login from 'domains/Login/application';
import App from 'domains/App/application'; 
import IntegrationNotistack from 'components/Notify';
import PropTypes from 'prop-types';

class Root extends Component {

    componentDidMount() {
        setTimeout(() => {
            this.redirect();
        }, 100);
    }

    static propTypes = {
        data: PropTypes.object.isRequired,
        dispatch: PropTypes.func.isRequired,
        history: PropTypes.object.isRequired,
        location: PropTypes.object.isRequired,
    };

    componentDidUpdate(prevProps) {
        const prevNotify = prevProps.data.notify;
        const currNotify = this.props.data.notify;
        if (currNotify.isNotify && currNotify !== prevNotify) {
            const data = { message: currNotify.message, severity: currNotify.severity };
            this.props.dispatch(hideNotify(data));
        }
    }
    
    redirect() {
        const { history, location } = this.props;
        if (this.props.data.access.isAccess) {
            if (location.pathname === '/login') {
                history.push('/');
            } else {
                history.push(`${location.pathname}`);
            }
        } else {
            this.props.dispatch(resetState());
            history.push('/login');
        }
    }

	handleAccess = (access, userId) => {
        let data = { ...access, isAccess : true, userId : userId }
		this.props.dispatch(updateAccessStatus(data));
    }
    
    shutDown = (e) => {
        e.preventDefault();
        const { history } = this.props;
        
		this.props.dispatch(resetState());
        history.push('/login');
    }

	render() {
        const { notify } = this.props.data;
        return (
            <React.Fragment>
                <IntegrationNotistack props={notify}/>
                    <Switch>
                        <Route path="/login" exact>
                            <Login state={this.props.data} handleAccess={this.handleAccess} />
                        </Route>
                        <Route path="/">
                            <App shutDown={this.shutDown} />
                        </Route>
                    </Switch>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return { 
        data: state
    }
}

const connect_root = connect(
    mapStateToProps
  )(Root);

export default withRouter(connect_root);